import validate from "/var/www/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/node_modules/@backmarket/nuxt-layer-oauth/middleware/auth.global.ts";
import guest_45global from "/var/www/node_modules/@backmarket/nuxt-layer-oauth/middleware/guest.global.ts";
import log_45ds_45version_45global from "/var/www/node_modules/@backmarket/nuxt-layer-design-system/middleware/logDsVersion.global.ts";
import _01_45client_45side_45navigation_45global from "/var/www/node_modules/@backmarket/nuxt-layer-base/middleware/01.clientSideNavigation.global.ts";
import _01_45redirect_45user_45if_45not_45logged_45global from "/var/www/apps/back-office-seller/middleware/01.redirectUserIfNotLogged.global.ts";
import _02_45fetch_45current_45user_45seller_45info_45global from "/var/www/apps/back-office-seller/middleware/02.fetchCurrentUserSellerInfo.global.ts";
import _03_45business_45features_45global from "/var/www/apps/back-office-seller/middleware/03.businessFeatures.global.ts";
import _04_45permissions_45global from "/var/www/apps/back-office-seller/middleware/04.permissions.global.ts";
import _05_45onboarding_45global from "/var/www/apps/back-office-seller/middleware/05.onboarding.global.ts";
import instrumentation_46setResourceName from "/var/www/packages/nuxt-module-instrumentation/src/runtime/middleware/setResourceName.ts";
import logger from "/var/www/packages/nuxt-module-logger/src/runtime/middleware.ts";
import payment_45content_45security_45policies_45headers from "/var/www/packages/nuxt-layer-payment/scopes/content-security-policies/middleware/paymentContentSecurityPoliciesHeaders.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  guest_45global,
  log_45ds_45version_45global,
  _01_45client_45side_45navigation_45global,
  _01_45redirect_45user_45if_45not_45logged_45global,
  _02_45fetch_45current_45user_45seller_45info_45global,
  _03_45business_45features_45global,
  _04_45permissions_45global,
  _05_45onboarding_45global,
  instrumentation_46setResourceName,
  logger,
  payment_45content_45security_45policies_45headers
]
export const namedMiddleware = {
  "fetch-customer-request-id-and-redirect": () => import("/var/www/apps/back-office-seller/middleware/fetchCustomerRequestIdAndRedirect.ts")
}